//  Link media
require.context('../media/', true, /^\.\/.*\.*/);
require.context('../fonts/', true, /^\.\/.*\.*/);


//  Styles
import '../styles/styles.scss';

// JS
import lazysizes from 'lazysizes';
import utils from './proj/utils';

import $ from 'jquery';
import Waypoint from 'Waypoint';
import Sizzle from './proj/sizzle.js';
import LazyLoad from './proj/lazyload.js';
import Plyr from './proj/Plyr.js';
import Tracker from './proj/Tracker';

import objectFitPolyfill from 'objectFitPolyfill';

const pkgJson = require('../../package.json');
const prodLinkFromPkg = pkgJson.prodUrl;
const slugFromPkg = pkgJson.slug;

var feedbackSent = false
import data from '../data.json';

$(document).ready(function () {

  const isMobileDevice = utils.mobileAndTabletCheck();
  const isMobile = window.innerWidth < 800 || isMobileDevice;
  $('body').addClass('start-app');

  // lazy sizes config
  lazysizes.cfg.customMedia = {
    '--device': '(max-width: 800px)',
    '--laptop': '(max-width: 1200px)',
    '--desktop': '(max-width: 1440px)',
  };

  const tracker = new Tracker(`${slugFromPkg}`);
  
  // DETECT SAFARI
  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    //alert('It\'s Safari');
    const theHTML = document.querySelector('html');
    theHTML.classList.add('safari');
  }


  document.addEventListener('DOMContentLoaded', function () {

    $('._trigger-crossfade').hover(
      function () {
        $(this).parents('._hover-parent').addClass('hover')
      },
      function () {
        $(this).parents('._hover-parent').removeClass('hover')
      }
    );

  });

  //lazyload images
  var lazyLoadInstance = new LazyLoad({
    elements_selector: "._lazy",
    callback_error: function () {
      console.log('error');
    }
  });

  //hyperlink 
  $('.answerResponse p a').attr('target', '_blank');

  //array for results section in quiz
  const resultsData = {
    "results": [{
        "cutoff": 8,
        "summary": "Great job! You're really on top of your news.",
        "social": "See if you can beat my score in CNN's weekly news quiz!"
      },
      {
        "cutoff": 5,
        "summary": "Not bad!",
        "social": "See if you can beat my score in CNN's weekly news quiz!"
      },
      {
        "cutoff": 3,
        "summary": "Eh, you could probably do better. Try again next week?",
        "social": "See if you can beat my score in CNN's weekly news quiz!"
      },
      {
        "cutoff": 0,
        "summary": "This just wasn't your week! Come back and test your smarts next week.",
        "social": "See if you can beat my score in CNN's weekly news quiz!"
      }
    ]
  }

  // SOCIAL: opens social in new  window
  function popupShare(url, title, w, h) {
    const left = (screen.width / 2) - (w / 2);
    const top = (screen.height / 2) - (h / 2);
    // open new tab in same browser
    return window.open(url, "_blank") 
    // open pop up
    // return window.open(url, title, 'toolbar=no, menubar=no, scrollbars=yes, resizable=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
  }

// This endpoint is only for completion and score tracking to feed data into quizbot
  const trackerPost = function (payload){
     //POST call to quiz metrics 
     const apiUrl = 'https://altystg077.execute-api.us-east-1.amazonaws.com/track';
     
     fetch(apiUrl, {
       method: 'POST', 
       headers: {
         'Content-Type': 'application/json',
       },
       body: JSON.stringify(payload),
     })
     .then(response => response.json())
     .then(payload => {
       console.log('Success!');
     })
     .catch((error) => {
       console.error('Error:', error);
     });
  }

  const sendFeedback = function(feedbackText){
    
    var feedback = {
      "feedback": feedbackText,
    }
    console.log(feedback);

    fetch(`https://submission.cnn.io/v3/forms/${slugFromPkg}`, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(feedback),
    })
    .then((res) => {
      // successful submission
      feedbackSent = true
      feedbackButton.disabled = true
      feedbackButton.innerText = "Submitted, Thank you"
      feedbackButton.style.color ='black'
    })
    .catch((err) => {
    // unsuccessful submission
      feedbackButton.innerText = "Please Resubmit"
      console.log(err);
    });
  }

  function quizQuestions(resultsData) {

    const numberOfQuestions = 10;
    const resultsSummary = document.getElementById('resultsSummary');
    const resultsScore = document.getElementById('resultsScore');
    const resultsTotal = document.getElementById('resultsTotal');
    let resultsSocial = null;
    let clickCount = 0;
    let correctCount = 0;
    let activated;
    let quizResults = resultsData.results;

    //checks that there is a feedback section and that it hasn't hasn't expired
    const feedback = data.content[2].value.feedback

    if (feedback){
      const expirationDate = new Date(feedback[1].value)
      const badExpirationDate = !expirationDate.getTime();
      const isExpired = new Date() > expirationDate;
      
      if((isExpired || badExpirationDate)) {
        //hide feedback section
        const feedbackContainer = document.getElementById('feedbackContainer')
        feedbackContainer.style.visibility="hidden";
        
      } else{

         //only add the listeners if we have a feedback section this week
        const feedbackButton = document.getElementById('feedbackButton')
        const feedbackTextArea = document.getElementById('feedbackText')
        feedbackTextArea.addEventListener("input", (e) =>{
          if(feedbackButton.disabled && !feedbackSent) feedbackButton.disabled = false;
          if(!feedbackButton.disabled && (feedbackTextArea.value.length === 0)) feedbackButton.disabled = true;
        })

        feedbackButton.addEventListener("click", (e) =>{
          sendFeedback(feedbackTextArea.value)
        })
      }
    }
    
    // QUIZ: check for the correct answer + counter
    $('.questionOption').click(function () {
      // if photo led question, unblur photo
      $(this).parents('.questionBlock').find('img').addClass('unblur');

      // make option and its "inactive"
      $(this).addClass('is-inactive');
      $(this).siblings().addClass('is-inactive');

      // get option value
      var correct = $(this).attr('correct');

      // get correct value
      var match = $(this).attr('option');

      // get closest answer heading - "Incorrect" or "Correct"
      var answerHeading = $(this).parents('.questionBlock').find('.answerResponseHeading');

      // if option value is equal to correct value 
      if (correct == match) {
        $(this).addClass('is-correct-answer');

        // keep track of the number of clicked CORRECT options
        correctCount++;

        $(answerHeading).text('Correct.');
      }
      // if option value is NOT equal to correct value
      else {
        // add "wrong-amswer" class
        $(this).addClass('is-wrong-answer');

        // populate heading in answer
        $(answerHeading).text('Incorrect.');

        // indicate the quiz option that is correct 
        $(this).siblings('[option=' + correct + ']').addClass('the-correct-answer');
      }

      // show answer copy
      var answer = $(this).parents('.questionBlock').find('.answerResponse');
      $(answer).addClass('is-visible');

      // make next question set "active"
      var nextQuestion = $(this).parents('.questionBlock').next('.questionBlock');
      $(nextQuestion).addClass('is-ready');

      // keep track of the number of clicked options
      clickCount++;

      // if number of selections is equal to number of questions, show results 
      if (clickCount == numberOfQuestions) {
        const results = document.getElementById('results');
        $(results).addClass('is-visible');

        //tracking quiz completions via Tracker
        tracker.trackMetric(`quiz-complete-${correctCount}`);
        const quizScore = { "slug": slugFromPkg, "score": correctCount};
        trackerPost(quizScore)    

        // show results copy based on score
        var i;
        for (i = 0; i < quizResults.length; i++) {
          if (correctCount >= quizResults[0].cutoff) {
            $(resultsSummary).text(quizResults[0].summary);
            $(resultsScore).text(correctCount);
            $(resultsTotal).text(numberOfQuestions);
            resultsSocial = quizResults[0].social;
          } else if (correctCount >= quizResults[1].cutoff) {
            $(resultsSummary).text(quizResults[1].summary);
            $(resultsScore).text(correctCount);
            $(resultsTotal).text(numberOfQuestions);
            resultsSocial = quizResults[1].social;
          } else if (correctCount >= quizResults[2].cutoff) {
            $(resultsSummary).text(quizResults[2].summary);
            $(resultsScore).text(correctCount);
            $(resultsTotal).text(numberOfQuestions);
            resultsSocial = quizResults[2].social;
          } else if (correctCount >= quizResults[3].cutoff) {
            $(resultsSummary).text(quizResults[3].summary);
            $(resultsScore).text(correctCount);
            $(resultsTotal).text(numberOfQuestions);
            resultsSocial = quizResults[3].social;
          } else if (correctCount >= quizResults[4].cutoff) {
            $(resultsSummary).text(quizResults[4].summary);
            $(resultsScore).text(correctCount);
            $(resultsTotal).text(numberOfQuestions);
            resultsSocial = quizResults[4].social;
          }
        }
      }
    });

    //may be able to change the names across the different social buttons, but for now the nav socials 
    // and resultsocials need to be selected separately then combined to loop through
    const resultSocials = document.querySelectorAll("a[class*='social']")
    const navSocials = document.querySelector(".cnnix__header__nav__contents__share").querySelectorAll("a[class*='share']")
    const recirc = document.querySelectorAll("a[class*='recirc_tracking']")
    let allTrackers = [...resultSocials , ...navSocials,  ...recirc]

    //replacing individual event listeners

    for (let i = 0; i < allTrackers.length; i++) {

      let social = allTrackers[i]
      social.addEventListener('click', e => {
        let data = social.getAttribute('data-trackmetric')
        let type = social.getAttribute('data-trackmetrictype')
        tracker.trackMetric(`${data}-${type}`);

        const link = prodLinkFromPkg;
        const summary = `I got ${correctCount} out of ${numberOfQuestions}. See if you can beat my score in CNN's weekly quiz!`
        //passed but not used in current state, could define size of pop up window
        const w = '500';
        const h = '439';

        let url = ''
        let title = ''

        switch(social.id){
          case 'facebook':
            url = `https://www.facebook.com/share.php?u=${link}`;
            title = 'Facebook';
            //quote was deprecated from sharer.php with no replacement, so we can't add a message
            //https://developers.facebook.com/support/bugs/734680371318112/?comment_id=743056360480513
          break;

          case 'twitter':
            title = 'Twitter';
            url = `https://www.twitter.com/intent/tweet?text=${summary}&url=${link}`;
          break;

          case 'whatsapp':
            title = 'whatsapp';
            url = `https://api.whatsapp.com/send?text= ${summary} ${link}`;
          break;

          //these get handled differently
          case 'email':
            url = `mailto:?subject= ${summary} &body=${link}`
            window.location.href = url
          break;

          case 'copy':
            e.preventDefault();
            e.stopPropagation();
            const pageURL = window.location.href; 
            // message for user that link is in clipoboard
            navigator.clipboard.writeText(pageURL).then(function() {
              $('.copied').addClass('is-visible');
              setTimeout(function(){
                $('.copied').removeClass('is-visible');
              }, 2000);	
            }, function(err) {
              console.error('Async: Could not copy text: ', err);
            });
          break;

          //leaving for reference
          // case 'twitter-nav' :
          // break

          // case 'facebook-nav' :
          // break

          default:
            //console.log('Unrecognized social share');
          break;

        }
        //exluding copy, email, twitter-nav and facebook-nav
        (['twitter', 'facebook', 'whatsapp'].includes(social.id))? popupShare(url, title, w, h) : null
      })
    }
  }

  quizQuestions(resultsData);
  

  //audio player
  const players = Plyr.setup('audio', {
    controls: ['play']
  });

  $('audio').bind('play', function () {
    activated = this;

    $('audio').each(function () {
      if (this != activated) {
        this.pause();
      }
    });
  });

  // Waypoint recalculations
  document.addEventListener('lazybeforeunveil', function (e) {
    Waypoint.refreshAll();
  });

});


// WEBPACK FOOTER //
// ./src/js/main.js